var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 41",
    style: {
      enableBackground: "new 0 0 100 41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.3,19.6V5.4h5.3v2.1h-3.3v3.7h2.4v2.1h-2.4v4.3h3.3v2.1H26.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.2,19.6l2.4-7.2l-2.4-7h2.1l1.2,4.2h0.1L37,5.4h2.1l-2.3,6.8l2.5,7.4h-2.1L35.8,15h-0.1l-1.4,4.6H32.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.6,19.6V5.4h3c1.1,0,1.9,0.3,2.4,1s0.8,1.7,0.8,3.1c0,1.3-0.2,2.4-0.7,3.2c-0.5,0.8-1.2,1.2-2,1.2h-1.4v5.8 H39.6z M41.6,11.8h0.8c0.5,0,0.8-0.2,1-0.5c0.2-0.3,0.3-0.9,0.3-1.8c0-0.8-0.1-1.4-0.3-1.7c-0.2-0.3-0.5-0.4-1-0.4h-0.7V11.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.5,19.6V5.4h5.3v2.1h-3.3v3.7h2.4v2.1h-2.4v4.3h3.3v2.1H46.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.1,13.6v6h-2V5.4h3c1.1,0,1.9,0.3,2.4,1C59,7,59.2,8,59.2,9.5c0,0.9-0.1,1.6-0.3,2.2s-0.5,1-1,1.3l1.5,6.6 h-2.1l-1.3-6H55.1z M55.1,7.4v4.1h0.8c0.5,0,0.8-0.2,1-0.5c0.2-0.3,0.3-0.9,0.3-1.7c0-0.7-0.1-1.3-0.3-1.6c-0.2-0.3-0.5-0.4-1-0.4 H55.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.6,19.6V5.4h2.1v14.3H60.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.1,19.6V5.4h5.3v2.1h-3.3v3.7h2.4v2.1h-2.4v4.3h3.3v2.1H64.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.7,19.6V5.4h1.8l2.6,8.5c0,0.2,0.1,0.4,0.2,0.7c0.1,0.3,0.1,0.6,0.2,0.9c-0.1-0.4-0.1-0.8-0.2-1.1 c0-0.4-0.1-0.6-0.1-0.8V5.4h1.9v14.3h-1.9l-2.5-7.9c0,0,0-0.1,0-0.1c-0.2-0.5-0.3-1-0.4-1.4c0.1,0.5,0.1,0.9,0.2,1.2 c0,0.3,0.1,0.6,0.1,0.7v7.5H70.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.3,16V8.6c0-1.1,0.3-2,0.8-2.6c0.6-0.6,1.3-1,2.3-1c0.9,0,1.7,0.3,2.2,1c0.6,0.7,0.8,1.5,0.8,2.7v1.4h-2.1 V8.5c0-0.5-0.1-0.9-0.3-1.1C82,7.2,81.8,7,81.4,7c-0.3,0-0.6,0.1-0.8,0.4c-0.2,0.2-0.3,0.6-0.3,1.1v8c0,0.5,0.1,0.9,0.3,1.1 c0.2,0.2,0.4,0.4,0.8,0.4c0.3,0,0.6-0.1,0.8-0.4c0.2-0.2,0.3-0.6,0.3-1.1v-1.9h2.1V16c0,1.2-0.3,2.2-0.8,2.9c-0.5,0.7-1.3,1-2.3,1 c-1,0-1.8-0.3-2.3-1C78.6,18.2,78.3,17.3,78.3,16z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.6,19.6V5.4h2.1v14.3H85.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.5,19.6l2.2-14.3h2.7l2.2,14.3h-2.1L93,16.5H91l-0.4,3.1H88.5z M91.2,14.5h1.6l-0.7-6H92L91.2,14.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.3,36.7V22.4h2.1v14.3H26.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.4,36.7V22.4h2.7l1.3,7.9c0.1,0.3,0.1,0.7,0.1,1c0,0.4,0,0.7,0,1.1c0-0.3,0-0.7,0.1-1c0-0.3,0.1-0.7,0.1-1.1 l1.3-7.9h2.7v14.3h-1.9v-9c0-0.3,0-0.6,0-1s0.1-0.9,0.1-1.4c0,0.2-0.1,0.5-0.1,0.8c-0.1,0.6-0.2,1-0.2,1.2L34,36.7h-1l-1.6-9.5 c-0.1-0.4-0.1-0.8-0.2-1.3c-0.1-0.5-0.1-0.7-0.1-0.8c0,0.5,0.1,0.9,0.1,1.4c0,0.4,0,0.8,0,1.1v9H29.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.8,36.7V22.4h3c1.1,0,1.9,0.3,2.4,1c0.5,0.7,0.8,1.7,0.8,3.1c0,1.3-0.2,2.4-0.7,3.2c-0.5,0.8-1.2,1.2-2,1.2 h-1.4v5.8H38.8z M40.8,28.9h0.8c0.5,0,0.8-0.2,1-0.5c0.2-0.3,0.3-0.9,0.3-1.8c0-0.8-0.1-1.4-0.3-1.7c-0.2-0.3-0.5-0.4-1-0.4h-0.7 V28.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.7,30.7v6h-2V22.4h3c1.1,0,1.9,0.3,2.4,1c0.5,0.7,0.7,1.7,0.7,3.1c0,0.9-0.1,1.6-0.3,2.2s-0.5,1-1,1.3 l1.5,6.6h-2.1l-1.3-6H47.7z M47.7,24.5v4.1h0.8c0.5,0,0.8-0.2,1-0.5s0.3-0.9,0.3-1.7c0-0.7-0.1-1.3-0.3-1.6c-0.2-0.3-0.5-0.4-1-0.4 H47.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53,25.7c0-1.1,0.3-2,0.8-2.6c0.6-0.6,1.3-1,2.3-1c0.9,0,1.7,0.3,2.2,1c0.6,0.7,0.8,1.5,0.8,2.7v7.3 c0,1.2-0.3,2.2-0.8,2.9c-0.5,0.7-1.3,1-2.3,1c-1,0-1.8-0.3-2.3-1c-0.5-0.7-0.8-1.7-0.8-3V25.7z M57.1,33.5v-8c0-0.5-0.1-0.9-0.3-1.1 c-0.2-0.2-0.4-0.4-0.8-0.4c-0.3,0-0.6,0.1-0.8,0.4c-0.2,0.2-0.3,0.6-0.3,1.1v8c0,0.5,0.1,0.9,0.3,1.1c0.2,0.2,0.4,0.4,0.8,0.4 c0.3,0,0.6-0.1,0.8-0.4C57,34.4,57.1,34,57.1,33.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.2,36.7V5.4h11.2v4.1H8.7v9h5.8v3.8H8.7v10.1h7.7v4.3H5.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.4,36.7V5.4H23v31.3H19.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoei);
export default __webpack_public_path__ + "static/media/logoei.6a68197499278b6b55a2dcc9a415ae39.svg";
export { ForwardRef as ReactComponent };